module.exports = __webpack_public_path__ + "@/assets/img/035-boy-15.43a0b61d.svg";